<template>
  <div>
    <v-combobox
      v-model="value.responsiblePerson"
      :items="userNames"
      :label="$t('dangerousGoods.dangerousGoodsList.form.responsiblePerson')"
      :loading="loading"
      data-cy="responsiblePerson"
      clearable
      dense
    ></v-combobox>
  </div>
</template>
<script>
export default {
  props: ["value"],
  data: () => ({
    userNames: [],
    loading: false,
  }),
  async created() {
    this.loading = true;
    try {
      const users = await this.$store.dispatch("getUsersData");
      this.userNames = (users || [])
        .map((user) => user.name)
        .filter(Boolean)
        .sort((a, b) =>
          String(a).localeCompare(String(b), undefined, { sensitivity: "base" }),
        );
    } finally {
      this.loading = false;
    }
  },
};
</script>
